import { ReactNode } from 'react';
import { toast, type ToastOptions } from 'react-toastify';
import { toAbsoluteUrl } from 'src/_metronic/helpers';

interface ToastContentProps {
	title: string;
	message: string;
	actions?: ReactNode;
}

interface CustomToastOptions extends ToastContentProps {
	options?: ToastOptions;
}

const TOAST_POSITION = 'bottom-right' as const;

const defaultOptions: ToastOptions = { position: TOAST_POSITION, theme: 'colored' };

const ToastContentTabol = ({ title, message, actions }: ToastContentProps) => {
	return (
		<div className="row row-cols-auto gx-5 align-items-top w-100">
			<div>
				<img alt="Logo" src={toAbsoluteUrl('/media/logos/tabol-logo-white.svg')} className="h-20px" />
			</div>
			<div className="w-1px flex-grow-1">
				<h6 className="text-white">{title}</h6>
				<p className="m-0">{message}</p>
				{actions && <div className="mt-3 d-flex justify-content-end gap-2">{actions}</div>}
			</div>
		</div>
	);
};

const ToastContentGeneric = ({ title, message }: ToastContentProps) => {
	return (
		<div className="row row-cols-auto gx-5 align-items-center w-100">
			<div className="w-1px flex-grow-1">
				<h6 className="text-white">{title}</h6>
				<p className="m-0">{message}</p>
			</div>
		</div>
	);
};

const useToast = () => {
	const toastInfo = (props: CustomToastOptions) => {
		toast.info(<ToastContentGeneric {...props} />, { ...defaultOptions, ...(props?.options ?? {}) });
	};

	const toastWarning = (props: CustomToastOptions) => {
		toast.warning(<ToastContentGeneric {...props} />, { ...defaultOptions, ...(props?.options ?? {}) });
	};

	const toastError = (props: CustomToastOptions) => {
		toast.error(<ToastContentGeneric {...props} />, { ...defaultOptions, ...(props?.options ?? {}) });
	};

	const toastTabol = (props: CustomToastOptions) => {
		const customOptions: ToastOptions = {
			className: 'bg-primary text-white',
			progressClassName: 'bg-white opacity-100',
			theme: 'colored',
		};

		toast(<ToastContentTabol {...props} />, { ...defaultOptions, ...customOptions, ...(props?.options ?? {}) });
	};

	return { toastInfo, toastWarning, toastError, toastTabol };
};

export default useToast;
